import { atom } from 'jotai';

export interface AtomRewindOptions<T> {
  key: string;
  default: () => Promise<T>;
  dangerouslyAllowMutability?: boolean;
}

export const RESET_SYMBOL = Symbol('RESET');
export type ResetSymbol = typeof RESET_SYMBOL;

/**
 * reset() することで options.default を再実行する Atom
 */
export function atomRewind<T>(options: AtomRewindOptions<T>) {
  // reset または set された回数
  const setCountAtom = atom(0);

  // set された場合は値を保持
  // reset された場合は reset されたことを保持
  let overrideValue: T | ResetSymbol = RESET_SYMBOL;

  return atom(
    get => {
      get(setCountAtom); // set と reset を購読
      return overrideValue === RESET_SYMBOL
        ? options.default() // reset されたので関数を再実行
        : Promise.resolve(overrideValue); // set された値をそのまま返す
    },
    (get, set, newValue: T | ResetSymbol) => {
      overrideValue = newValue;
      set(setCountAtom, count => count + 1);
    }
  );
}
